// core version + navigation, pagination modules:
import { $qs, $qsa } from "./utils/QuerySelector";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import tailwindConfig from "../../tailwind.config";

gsap.registerPlugin(ScrollTrigger);

function contact() {
	let mm = gsap.matchMedia();

	const screenMD = tailwindConfig.theme.screens.md.replace("px", "");

	const contactMap = $qs('[data-name="contactMap"]');
	const contactTopCurtain = $qs('[data-name="contactTopCurtain"]');
	const contactTop = $qs('[data-name="contactTop"]');
	const contactIntro = $qs('[data-name="contactIntro"]');
	const contactForm = $qs('[data-name="contactForm"]');

	if (!contactForm) return;

	mm.add("(min-width: " + tailwindConfig.theme.screens.lg + ")", () => {
		gsap.set(contactForm, { opacity: 0 });

		let scrollTL = new gsap.timeline({ ease: "linear" });

		scrollTL
			.addLabel("start")
			.to(
				contactMap,
				{
					x: "100%",
					duration: 1,
				},
				"start"
			)
			.to(
				contactTopCurtain,
				{
					opacity: 1,
					duration: 1,
				},
				"start"
			)
			.to(
				contactIntro,
				{
					opacity: 0,
					duration: 0.5,
				},
				"start"
			);

		ScrollTrigger.create({
			animation: scrollTL,
			trigger: contactTop,
			start: "top top",
			end: () => `+=${window.innerHeight}px`,
			scrub: true,
			pin: contactTop,
			pinSpacing: false,
			//markers: true,
		});

		let scrollFormTL = new gsap.timeline({ ease: "linear" });
		gsap.set(contactForm, { pointerEvents: "none" });
		scrollFormTL
			.addLabel("start")
			.to(contactForm, { opacity: 1, duration: 0.5 }, "+=0.5")
			.set(contactForm, { pointerEvents: "auto" }, "-=0.35");

		ScrollTrigger.create({
			animation: scrollFormTL,
			trigger: contactForm,
			start: "top top",
			end: () => `+=${window.innerHeight}px`,
			scrub: true,
			pin: contactForm,
			pinSpacing: true,
			//markers: true,
		});
	});
}

export default contact;
